import React from 'react';
import { CheckBalanceTypes } from '../../CheckBalanceTypes';
import { weakKey } from '../../../../utilities/weakKey';
import {
  getTransactionMethod,
  convertDateFormat,
} from '../../helpers/TransactionsDetailsHelper';
import { transactionHelpersLabels } from '../../constants/accountPanelConfigs';

export const TransactionsDetails = ({
  ledgerTransactionInfo = [],
}: CheckBalanceTypes.TTransactionDetails) => {
  const latestTransactions = [...ledgerTransactionInfo].reverse().slice(0, 5);
  const {
    tableColumnsLabels: { col1, col2, col3, col4, col5 },
    transactionSubSectionLabel,
  } = transactionHelpersLabels;
  const TransactionDetailsTable = () => {
    return (
      <div className="tableContainer">
        <table className="transactionsTable">
          <thead>
            <tr>
              <th>
                <p className="subtitle1">{col1}</p>
              </th>
              <th>
                <p className="subtitle1">{col2}</p>
              </th>
              <th>
                <p className="subtitle1">{col3}</p>
              </th>
              <th>
                <p className="subtitle1">{col4}</p>
              </th>
              <th>
                <p className="subtitle1">{col5}</p>
              </th>
            </tr>
          </thead>
          <tbody>
            {latestTransactions.map(
              ({
                entry_date,
                to_date,
                charged,
                paid,
                description,
                customer_type,
                client_type,
              }) => (
                <tr key={weakKey({ entry_date })}>
                  <td>{convertDateFormat(entry_date)}</td>
                  <td>
                    {to_date
                      ? convertDateFormat(to_date)
                      : convertDateFormat(entry_date)}
                  </td>
                  <td className="smallColumn">${charged ?? paid}</td>
                  <td className="mediumColumn">
                    {charged ? description : 'Not Available'}
                  </td>
                  <td className="smallColumn">
                    <span>
                      {getTransactionMethod(
                        customer_type,
                        client_type,
                        description
                      )}
                    </span>
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="transactionHistoryParentContainer">
      <div className="transactionHistoryContainer">
        <div className="transactionHistoryLabel">
          <h5>{transactionSubSectionLabel}</h5>
        </div>
        {latestTransactions.length > 0 ? (
          <TransactionDetailsTable />
        ) : (
          <p className="subtitle1">No Transaction Details Available</p>
        )}
      </div>
    </div>
  );
};
